export default __webpack_public_path__ + "static/media/portfolio-smc360-3.73c5a9fd.jpg";